var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hideEmptyIcon)?_c('icon-no-data-cry',{staticClass:"w-64"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }